import { render, staticRenderFns } from "./DeviceGuard.vue?vue&type=template&id=46a1add0&scoped=true&"
import script from "./DeviceGuard.vue?vue&type=script&lang=js&"
export * from "./DeviceGuard.vue?vue&type=script&lang=js&"
import style0 from "./DeviceGuard.vue?vue&type=style&index=0&id=46a1add0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a1add0",
  null
  
)

export default component.exports